import { Box, Tab, Tabs, styled } from '@mui/material'
import { colors } from 'constants/theme'

const tabsForwardProps = new Set([
  'selectionFollowsFocus', 'textColor', 'indicator',
  'fullWidth', 'centered', 'visibleScrollbar',
])

export const CustomTabs = styled(Tabs, {
  shouldForwardProp: (p) => !tabsForwardProps.has(p as string),
})(() => ({
  borderBottom: `1px solid ${colors.lightGray}`,
  '.MuiTab-root': {
    textTransform: 'none',
    fontSize: 15,
    '&.Mui-selected': { color: colors.themeSecondColor },
  },
  '.MuiTabs-indicator': {
    backgroundColor: colors.themeSecondColor,
    height: 3,
  },
}))

export const CustomTab = styled(Tab, {
  shouldForwardProp: (p) => !tabsForwardProps.has(p as string),
})(() => ({}))

export const LayoutRoot = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}))
